'use strict';
const angular = require('angular');
const {isFunction, isObject} = angular;

export function FirebaseListenerProvider() {
  var EVENT_TYPES = {};

  Object.defineProperties(EVENT_TYPES, {
    child_added: {value: 'child_added'},
    child_changed: {value: 'child_changed'},
    child_removed: {value: 'child_removed'},
    value: {value: 'value'}
  });

  return {
    $get: [
      '$window',
      'AbstractEventListener',
      function (
        $window,
        AbstractEventListener,
      ) {
        function FirebaseListener(
          reference,
          eventType,
          callback,
          cancelCallback,
          context,
          options,
        ) {
          if (!(reference instanceof $window.Firebase)) throw new Error('FirebaseListener: reference must be a valid Firebase reference!');
          if (cancelCallback && !isFunction(cancelCallback)) throw new Error('FirebaseListener: cancelCallback must be a function or nothing!');
          options = isObject(options) ? options : {};

          var modifiedCallback = options.bindOnce ?
            createBindOnceCallback(this, callback, context) :
            callback;

          Object.defineProperties(this, {
            reference: {configurable: false, enumerable: false, writable: false, value: reference},
            cancelCallback: {configurable: false, enumerable: false, writable: false, value: cancelCallback}
          });

          AbstractEventListener.call(this, FirebaseListener, {
            callback: modifiedCallback,
            eventType: eventType,
            context: context,
            id: options.id,
            start: options.start
          })
        }

        AbstractEventListener.__inheritFrom(FirebaseListener, {
          eventTypes: EVENT_TYPES,
          create: create,
          destroy: destroy
        });

        // initialization logic goes here. on complete, it is replaced with resume.
        function create() {
          if (this.context) {
            this.reference.on(this.eventType, this.callback, this.cancelCallback, this.context);
          } else {
            this.reference.on(this.eventType, this.callback, this.cancelCallback);
          }
        }

        function destroy() {
          if (this.context) {
            this.reference.off(this.eventType, this.callback, this.context);
          } else {
            this.reference.off(this.eventType, this.callback);
          }
        }

        /**
         *
         * @param {FirebaseListener} listener
         * @param {Function} callback
         * @param {Object} context
         * @returns {Function} bound once callback
         */
        function createBindOnceCallback(listener, callback, context) {
          return function (ss) {
            callback.apply(context, arguments);

            if (ss.val() && listener.isAlive()) {
              listener.destroy();
            }
          }
        }

        return FirebaseListener;
      }]
  };
}


// WEBPACK FOOTER //
// ./src/js/_libs/angular-fire-util/FirebaseListener.js